import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleGT56UHD = () => {
  console.log('🎯 SimpleGT56UHD component loading');
  
  const product = findProductById("gt56uhd-chirp");
  
  if (!product) {
    console.error('Product not found:', "gt56uhd-chirp");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gt56uhd-chirp"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleGT56UHD; 